import { observable } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { NOOP_LOGGER } from 'bernie-logger';

import { ChildModel } from './child-model';

interface RoomModelProps {
  adults?: number;
  children?: ChildModel[];
}

export class RoomModel extends Store {
  constructor(state: RoomModelProps = {}) {
    super({}, NOOP_LOGGER);

    this.setState(state);
  }

  private setState(state: RoomModelProps) {
    this.adults = state?.adults ?? RoomModel.DEFAULTS.adults;
    this.children = state?.children?.map(child => new ChildModel(child)) ?? RoomModel.DEFAULTS.children;
  }
  public static DEFAULTS = {
    adults: 2,
    children: [],
  };

  @observable
  public adults = 0;
  @observable
  public children: ChildModel[] = [];

  public clone(): RoomModel {
    return new RoomModel({
      adults: this.adults,
      children: this.children,
    });
  }

  public hydrate(state: RoomModelProps): void {
    this.setState(state);
  }
}
